import { Component, inject } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { RouterOutlet } from '@angular/router';
import { TranslocoService } from '@jsverse/transloco';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: true,
    imports: [RouterOutlet],
})
export class AppComponent {
    private title = inject(Title);
    private meta = inject(Meta);
    private translocoService = inject(TranslocoService);

    constructor() {
        this.translocoService.langChanges$.subscribe((lang) => {
            this.translocoService
                .selectTranslateObject('seo')
                .subscribe((seo) => {
                    this.title.setTitle(seo.title);
                    this.meta.updateTag({
                        name: 'description',
                        content: seo.description,
                    });
                    this.meta.updateTag({
                        property: 'og:title',
                        content: seo.title,
                    });
                    this.meta.updateTag({
                        property: 'og:description',
                        content: seo.description,
                    });
                    document.documentElement.lang = lang;
                });
        });
    }
}
